/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const PortugalSpecificHeader = ({
 contactDetails, invoiceNumber, transaction
}) => {
  const {
    RL_CertificateName,
    RL_CustomerLastName,
    RL_CustomerFirstName,
    RL_CustomerAddress,
    RL_City,
    RL_PostalCode,
    RL_Country,
  } = useSelector((state) => state);
  const contactPrimary = contactDetails.find((item) => item.TypeCode === 'Primary');
  const firstName = contactPrimary?.Name && contactPrimary?.Name?.Names && contactPrimary?.Name?.Names?.[0]?.NamePart;
  const lastName = contactPrimary?.Name && contactPrimary?.Name?.Names && contactPrimary?.Name?.Names?.[1]?.NamePart;
  const custCountry = contactPrimary?.Addresses && contactPrimary?.Addresses?.[0]?.Country;
  const postal = contactPrimary?.Addresses && contactPrimary?.Addresses?.[0]?.PostalCode;
  const city = contactPrimary?.Addresses && contactPrimary?.Addresses?.[0]?.City;
  const line = contactPrimary?.Addresses?.[0].AddressLines && contactPrimary?.Addresses?.[0].AddressLines?.[0]?.Line;
  const id = contactPrimary?.ID;
  const cityName = city?.split(',').slice(-1)?.[0];
  const QRCode = transaction?.QRCode;
  const startIndex = QRCode && QRCode.indexOf('Q:') + 2;
  const endIndex = QRCode && QRCode.indexOf('*', startIndex);
  const extractedValue = QRCode && QRCode.substring(startIndex, endIndex);

  return (
    <>
      <p> {transaction.RetailTransaction?.LineItems && transaction?.RetailTransaction.LineItems?.[0]?.Sale && 'FACTURA' }</p>
      <p> {transaction.RetailTransaction?.LineItems && transaction?.RetailTransaction.LineItems?.[0]?.Return && ' NOTA DE CRÉDITO' }</p>
      <br />
      <article className="justify-between align-left display-block">
        <p>{invoiceNumber && `Documento.: ${invoiceNumber}`}</p>
      </article>
      {QRCode && (
        <article className="justify-between align-left display-block">
          <p className="align-left">{RL_CertificateName}: {extractedValue}-Processado por programa certificado n°.1630/AT</p>
        </article>
  )}
      {firstName && (
        <article className="justify-between align-left display-block">
          <p className="align-left">{RL_CustomerFirstName}: {firstName}</p>
        </article>
  )}
      {lastName && (
      <article className="justify-between align-left display-block">
        <p className="align-left">{RL_CustomerLastName}: {lastName}</p>
      </article>
  )}
      {line && (
        <article className="justify-between align-left display-block">
          <p className="align-left">{RL_CustomerAddress}: {line}</p>
        </article>
  )}
      {cityName && (
        <article className="justify-between align-left display-block">
          <p className="align-left">{RL_City}: {cityName}</p>
        </article>
  )}
      {postal && (
        <article className="justify-between align-left display-block">
          <p className="align-left">{RL_PostalCode}: {postal}</p>
        </article>
  )}
      {custCountry && (
        <article className="justify-between align-left display-block">
          <p className="align-left">{RL_Country}: {custCountry}</p>
        </article>
  )}
      {id && (
        <article className="justify-between align-left display-block">
          <p className="align-left">N.I.F: {id}</p>
        </article>
  )}
      <br />
    </>
);
};

PortugalSpecificHeader.defaultProps = {
  contactDetails: [],
  invoiceNumber: '',
  transaction: {},
};

PortugalSpecificHeader.propTypes = {
  contactDetails: PropTypes.arrayOf(PropTypes.shape()),
  invoiceNumber: PropTypes.string,
  transaction: PropTypes.objectOf(PropTypes.shape()),
};

export default PortugalSpecificHeader;
